import React from "react";
import "./Privacy.css";
import { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  return (
    <div className="privacy-wrapper">
      <div className="privacy-container">

        <h1>Privacy Policy</h1>
        <p className="effective-date">
          Effective Date: January 1, 2026
        </p>

        <p className="intro-text">
          Forge Your Peak (“we”, “our”, or “us”) is committed to protecting your privacy.
          This Privacy Policy explains how we collect, use, and safeguard your
          information when you access our website, reaction speed games, visual tests,
          dashboards, training programs, and related services.
        </p>

        <hr />

        {/* 1 */}
        <h2>1. Information We Collect</h2>
        <p>We may collect the following categories of information:</p>
        <ul>
          <li><strong>Personal Information:</strong> Name, email address, phone number, login credentials.</li>
          <li><strong>Performance Data:</strong> Visual acuity scores, reaction times, cognitive results, training metrics.</li>
          <li><strong>Technical Data:</strong> IP address, browser type, device type, cookies, and usage analytics.</li>
          <li><strong>Payment Information:</strong> Processed securely via third-party providers. We do not store full card details.</li>
        </ul>

        {/* 2 */}
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To provide access to tests, games, and performance dashboards.</li>
          <li>To store, analyze, and display your performance metrics.</li>
          <li>To improve platform functionality and user experience.</li>
          <li>To send important updates or service-related communications.</li>
          <li>To maintain security and prevent fraud.</li>
        </ul>

        {/* 3 */}
        <h2>3. Data Storage & Security</h2>
        <p>
          We implement reasonable technical and organizational safeguards to protect
          your data. While we strive to protect your personal information,
          no digital system can guarantee absolute security.
        </p>

        {/* 4 */}
        <h2>4. Sharing of Information</h2>
        <p>
          We do not sell your personal data. We may share limited information
          with trusted service providers such as hosting, analytics, and payment
          processors strictly for operational purposes.
        </p>

        {/* 5 */}
        <h2>5. Cookies & Analytics</h2>
        <p>
          We may use cookies and similar tracking technologies to enhance performance,
          analyze usage patterns, and improve the user experience.
        </p>

        {/* 6 */}
        <h2>6. Your Rights</h2>
        <ul>
          <li>Access your stored information.</li>
          <li>Request corrections to inaccurate data.</li>
          <li>Request account deletion.</li>
          <li>Opt out of marketing communications.</li>
        </ul>

        {/* 7 */}
        <h2>7. Children’s Privacy</h2>
        <p>
          If our services are used by minors through schools or sports institutions,
          data is collected only with appropriate parental or institutional consent.
        </p>

        {/* 8 */}
        <h2>8. Policy Updates</h2>
        <p>
          We may update this Privacy Policy from time to time.
          Changes will be reflected by revising the effective date.
        </p>

        {/* 9 */}
        <h2>9. Contact Us</h2>
        <p>If you have any questions regarding this Privacy Policy, please contact:</p>
        <p className="email">support@forgeyourpeak.com</p>

      </div>
    </div>
  );
};

export default PrivacyPolicy;